var _style, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoyaltyDonate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_2_);}\n\t.st1{fill:#ECDCF4;}\n\t.st2{fill:#FFFFFF;filter:url(#Adobe_OpacityMaskFilter);}\n\t.st3{mask:url(#mask0_408_18_1_);}\n\t.st4{fill:#194142;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    y: 0,
    width: 64,
    height: 64
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M32,64c17.7,0,32-14.3,32-32S49.7,0,32,0S0,14.3,0,32S14.3,64,32,64z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 18.7,
    y: 20,
    width: 26.7,
    height: 23.4
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 18.7,
    y: 20,
    width: 26.7,
    height: 23.4,
    id: "mask0_408_18_1_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M45.3,20H18.7v23.4h26.7V20z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M32,43.4c-0.2,0-0.4-0.1-0.5-0.2c-0.3-0.3-0.7-0.6-1.1-0.9c-5.7-4.6-14.3-11.7-11-18.4c1.3-2.6,4-4.1,6.8-4 c2.5,0.1,3.7,1.2,5.5,2.8c0.1,0.1,0.2,0.2,0.3,0.3c0.1-0.1,0.2-0.2,0.3-0.3c1.7-1.5,3-2.6,5.5-2.8c2.9-0.2,5.5,1.4,6.8,3.9 c3.3,6.7-5.3,13.7-11,18.4c-0.4,0.3-0.7,0.6-1.1,0.9C32.4,43.3,32.2,43.4,32,43.4L32,43.4z M25.8,21.7c-2.1,0-4,1.2-4.9,3 C18.2,30.2,26.5,37,31.5,41c0.2,0.2,0.4,0.3,0.5,0.4c0.2-0.1,0.4-0.3,0.5-0.4c5-4,13.2-10.8,10.6-16.3c-1-2-3-3.2-5.2-3 c-1.9,0.1-2.8,0.9-4.5,2.4c-0.3,0.2-0.6,0.5-0.9,0.8c-0.3,0.3-0.8,0.3-1.1,0c-0.3-0.3-0.6-0.5-0.9-0.8c-1.7-1.5-2.6-2.3-4.5-2.4 C26,21.7,25.9,21.7,25.8,21.7L25.8,21.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M32,43.4c-0.5,0-0.8-0.4-0.8-0.8V24.2c0-0.5,0.4-0.8,0.8-0.8c0.5,0,0.8,0.4,0.8,0.8v18.4 C32.8,43,32.5,43.4,32,43.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M36.2,35c-0.2,0-0.4-0.1-0.6-0.2l-4.2-4.2c-0.3-0.3-0.3-0.9,0-1.2c0.3-0.3,0.9-0.3,1.2,0l4.2,4.2 c0.3,0.3,0.3,0.9,0,1.2C36.6,35,36.4,35,36.2,35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M27.8,35c-0.2,0-0.4-0.1-0.6-0.2c-0.3-0.3-0.3-0.9,0-1.2l4.2-4.2c0.3-0.3,0.9-0.3,1.2,0 c0.3,0.3,0.3,0.9,0,1.2l-4.2,4.2C28.2,35,28,35,27.8,35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M37.1,30.9H32c-0.3,0-0.6-0.2-0.8-0.5c-0.1-0.3-0.1-0.7,0.2-0.9l3.6-3.6c1.2-1.2,3-1.2,4.2,0 c0.6,0.6,0.9,1.3,0.9,2.1c0,0.8-0.3,1.5-0.9,2.1C38.7,30.6,37.9,30.9,37.1,30.9L37.1,30.9z M34,29.2h3.1c0.3,0,0.7-0.1,0.9-0.4 c0.2-0.2,0.4-0.6,0.4-0.9S38.3,27.2,38,27c-0.5-0.5-1.3-0.5-1.8,0L34,29.2L34,29.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M32,30.9h-5.1c-0.8,0-1.5-0.3-2.1-0.9c-1.2-1.2-1.2-3,0-4.2c0.6-0.6,1.3-0.9,2.1-0.9c0.8,0,1.5,0.3,2.1,0.9 l3.6,3.6c0.2,0.2,0.3,0.6,0.2,0.9C32.6,30.7,32.3,30.9,32,30.9L32,30.9z M26.9,26.6c-0.3,0-0.7,0.1-0.9,0.4 c-0.5,0.5-0.5,1.3,0,1.8c0.2,0.2,0.6,0.4,0.9,0.4H30L27.8,27C27.5,26.8,27.2,26.6,26.9,26.6L26.9,26.6z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoyaltyDonate);
export default __webpack_public_path__ + "static/media/loyalty_donate.f29582c7177364c0bcd88b193459822d.svg";
export { ForwardRef as ReactComponent };